var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center overflow-hidden"},[_c('img',{staticClass:"object-cover w-full select-none pointer-events-none",attrs:{"src":((_vm.image.indexOf('http')===-1 && _vm.image.indexOf('data:image')===-1) ?
  'https://scontent.teleportravel.com/img/' : '' ) + _vm.image,"alt":"Banner"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }